// Starts motion drawn outside a FeatureMotion stage the way the stage starts its own: without JS
// or with reduce-motion on, the element keeps its resting style (the last frame); once mounted it
// holds the first frame (`armed`) until it scrolls into view, then plays once (`running`).
// Bind both to the element: `{ 'is-run': running || armed, 'is-armed': armed }`, and write every
// animation under `.is-run`, with `.is-armed` pausing it, as components/FeatureMotion.vue does.
export function useMotionInView(target, { threshold = 0.35, rootMargin = "0px" } = {}) {
  const running = ref(false);
  const armed = ref(false);
  const reduced = ref(false);
  let observer = null;

  onMounted(() => {
    reduced.value = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced.value || !target.value) return;
    armed.value = true;
    observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      armed.value = false;
      running.value = true;
    }, { threshold, rootMargin });
    observer.observe(target.value);
  });

  onBeforeUnmount(() => observer?.disconnect());

  return { running, armed, reduced };
}
